<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormAd @submit="submit" :title="'Add Ad'" :form="{region: null, branch: null, device: null, enabled: false}"></FormAd>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import FormAd from '@/views/ads/FormAd'

export default {
  name: 'addad',
  components: {
    FormAd
  },
  methods: {
    submit (form) {

      let scope = this; 

      form.user = scope.$store.getters.currentUser.id
      form.impressions = 0;
      form.clicks = 0;

      axios.post(process.env.VUE_APP_API + '/ad', form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {

          if(form.type === 'image') {

            let formData = new FormData();

            if(form.file) {

              formData.append('file', form.file);
              formData.append('fileName', response.data._id);

              axios.post(process.env.VUE_APP_API + '/ad/upload',
                formData,
                {
                  headers: {
                      Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token'),
                      'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(function(){
                scope.$router.push('/ads/list')
              })
              .catch(function(){
                console.log('Failed to upload file!!');
              });
              
            }

          } else  {
            scope.$router.push('/ads/list')
          }

        })
        .catch(function (error) {
          console.log(error);
        });
      
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
